// removed by extract-text-webpack-plugin
module.exports = {"xl":"_2fjGD","l":"_144GS","ltext":"_1XbH_","page":"_3EkAU","m":"_-H_JB","text":"bako_","textblock":"_1Nz81","text-narrow":"_3H2aO","s":"_1XxUy"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styleTools/SizeClasses.scss
 ** module id = 72
 ** module chunks = 0
 **/